<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="mt-2 flex flex-col justify-center py-6">
    <customer-portal-kc-message
      class="relative bottom-5"
    ></customer-portal-kc-message>
    <div class="flex justify-center">
      <a
        class="revolution ef-branding flex justify-center gap-2"
        mat-button
        mat-stroked-button
        color="secondary"
        [href]="clientData.baseUrl"
        *ngIf="clientData.baseUrl"
      >
        <mat-icon svgIcon="chevron_left"></mat-icon>
        {{ 'back' | sharedTranslate }}
      </a>
    </div>
  </div>
</div>
